var $0f6a34bf23c8fd5d$exports = {};
$0f6a34bf23c8fd5d$exports = {
    "invalidSelection": (args, formatter)=>`\u{9078}\u{629E}\u{3057}\u{305F}${formatter.plural(args.selectedCount, {
            one: `\u{65E5}\u{4ED8}`,
            other: `\u{65E5}\u{4ED8}`
        })}\u{306F}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`
};


export {$0f6a34bf23c8fd5d$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
